export class DeferHandler {
    constructor(component) {
        this.component = component;
    }
}
//# sourceMappingURL=defer-handler.js.map